import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendStatusUpdateBySMS = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const send = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
      .send_ticket_status_by_sms()
      .then(() => {
        setLoading(false)
        dispatch(showSuccessToast('Sent Ticket Status By SMS'))
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Status Status By SMS'))
      })
  }

  return (
    <ReactBootstrap.Dropdown.Item
      onClick={() => send()}
      block
      variant="outline-info"
    >
      {loading ? <components.Loading /> : 'Send Status Update By SMS'}
    </ReactBootstrap.Dropdown.Item>
  )
}
